import React, { Component } from 'react'
import ReactMarkdown from 'react-markdown'
import { H2, Flex } from '@raysync/common/components'
import intl from 'react-intl-universal'
import { ArticleContainer, ArticleWrap, ArticleContent, NavigationWrap, NavigationBox, HeaderItem } from './atoms'
import { useMarkdownNavigation } from '@raysync/common/hooks'
function Article({ article, title, showHeaders = true }) {
  const { headers, activeId } = useMarkdownNavigation('document-content')
  const handleClick = id => {
    if (typeof window !== 'undefined') {
      const anchorElement = document.getElementById(id)
      if (anchorElement) {
        const distanceFromTop = anchorElement.getBoundingClientRect().top
        const offset = 100
        window.scrollBy({
          top: distanceFromTop - offset,
          behavior: 'smooth',
        })
      }
    }
  }
  return (
    <ArticleContainer>
      <H2>{title}</H2>
      <ArticleWrap>
        <ArticleContent>
          <div id='document-content'>
            <ReactMarkdown source={article} escapeHtml={false} linkTarget='_blank' />
          </div>
        </ArticleContent>
        {showHeaders && (
          <NavigationWrap>
            {headers.length > 0 && (
              <NavigationBox>
                <h4>目录</h4>
                <ul>
                  {headers.map(header => (
                    <li key={header.id}>
                      <HeaderItem
                        actived={header.id === activeId}
                        onClick={() => {
                          handleClick(header.id)
                        }}
                      >
                        {header.text}
                      </HeaderItem>
                    </li>
                  ))}
                </ul>
              </NavigationBox>
            )}
          </NavigationWrap>
        )}
      </ArticleWrap>
    </ArticleContainer>
  )
}
export default Article
